import {use} from 'react'

import {TableContext} from '../../../../hooks/tanstack-table/providers/table-provider'
import type {MemexItemModel} from '../../../../models/memex-item-model'
import {useGetVisibleRows} from '../use-visible-rows'

/**
 * Safely gets visible rows function, returning undefined if not in table context
 */
export function useSafeGetVisibleRows(): (() => Array<{id: string | number; original: MemexItemModel}>) | undefined {
  const tableContext = use(TableContext)

  try {
    const getVisibleRows = useGetVisibleRows()
    return tableContext ? getVisibleRows : undefined
  } catch {
    return undefined
  }
}
